// 6-digit code entry (iOS OTPVerificationView): six boxes backed by one real input,
// so typing, pasting and the browser's one-time-code autofill all work.
import React, { useState } from 'react';

export const OTP_LENGTH = 6;

export default function OtpInput({ id, value, onChange, disabled, autoFocus, label = 'Verification code' }) {
  const [focused, setFocused] = useState(false);
  const digits = value.split('');
  const active = Math.min(value.length, OTP_LENGTH - 1);

  return (
    <div className={`lx-otp${disabled ? ' is-disabled' : ''}`}>
      <input
        id={id}
        className="lx-otp-input"
        aria-label={label}
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={OTP_LENGTH}
        value={value}
        disabled={disabled}
        autoFocus={autoFocus}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, OTP_LENGTH))}
      />
      <div className="lx-otp-boxes" aria-hidden>
        {Array.from({ length: OTP_LENGTH }, (_, i) => (
          <span key={i} className={`lx-otp-box${focused && i === active ? ' is-active' : ''}${digits[i] ? ' is-filled' : ''}`}>
            {digits[i] || ''}
          </span>
        ))}
      </div>
    </div>
  );
}
